import { render, staticRenderFns } from "./MonthlyCard.vue?vue&type=template&id=72665545&scoped=true&"
import script from "./MonthlyCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyCard.vue?vue&type=style&index=0&id=72665545&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72665545",
  null
  
)

export default component.exports